import { handleActions } from 'redux-actions';
// import { combineReducers } from 'redux';
import * as autoSearchActions from '../actions/autoSearchActions';

const initState = {
  status: '',
  data: null,
  autoSearchError: '',
};

export const autoSearch = handleActions(
  {
    [autoSearchActions.autoSearchByNum]: (state, _action) => {
      return (state = {
        isLoading: true,
        status: 'validating',
        data: null,
        autoSearchError: '',
      });
    },
    [autoSearchActions.autoSearchByNumSuccess]: (state, { payload }) => {
      return (state = {
        isLoading: false,
        status: 'success',
        data: payload,
        autoSearchError: '',
      });
    },
    [autoSearchActions.autoSearchByNumError]: (state, action) => {
      return (state = {
        isLoading: false,
        status: 'error',
        data: null,
        autoSearchError:
          action.payload && action.payload.message
            ? action.payload.message
            : 'Совпадений не найдено',
      });
    },
    [autoSearchActions.autoSearchByNumReset]: () => null,
  },
  initState
);
